export default (src = "") => ({
  activeSrc: "",
  isOpen: false,
  src,

  open() {
    this.activeSrc = this.src;
    this.isOpen = true;
  },

  close() {
    this.isOpen = false;
    this.activeSrc = "";
  },
});
